import React from 'react'
import {moneda} from '../../util/index';
import { Button, Header, Icon, Modal, Segment, Form,  Dimmer, Table, Progress, Input, Checkbox, Divider} from 'semantic-ui-react'
import { DatePicker, Space } from 'antd';
//import "antd/dist/antd.css";
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
import dayjs from 'dayjs';
const dateFormat = 'DD/MM/YYYY';

const ModalPagos = ({showModal, closeModal, modulos, strings, pagosLista, onChange, pagoSave, fechas}) => (
    
  
    
  <Modal open={showModal}  size='medium' >
  <Segment >
    
     <Modal.Content scrolling>
    
        {pagosLista.length>0?
    
         <Table>
                <Table.Header>
                    <Table.Row>
                    
                    <Table.HeaderCell>{strings?strings["fecha"]:""}</Table.HeaderCell>
                    <Table.HeaderCell textAlign="right">{strings?strings["montoPago"]:""}</Table.HeaderCell>
                    <Table.HeaderCell textAlign="right">{strings?strings["referencia"]:""}</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">{strings?strings["guardar"]:""}</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
    
            
    
                <Table.Body>
    
                  {pagosLista.map(pago =>
    
    
                    <Table.Row>
                    <Table.Cell>
    
                        <DatePicker bordered={false}                  
                            onChange={(dates, dateStrings)=>fechas(dates, dateStrings, pago.id)} 
                            locale={locale} 
                            size="large" 
                            value={dayjs(pago.fechaPago, dateFormat)}
                            allowClear={false}
                            format={dateFormat} />    
    
    
                    </Table.Cell>
                    <Table.Cell textAlign="right">{moneda(pago.montoPago)}</Table.Cell>
                    <Table.Cell textAlign="right">
                        {pago.pagado==0?
                            <Form>                                    
                                <Form.Field  required  error={pago.error}>                               
                                    <Input
                                    placeholder={strings?strings["referencia"]:""} 
                                    name="referencia"
                                    onChange={(event, data)=>onChange(event, data, pago.id)}
                                    value={pago.referencia}
                                    icon='edit'/>
                                </Form.Field>
                            </Form>   
                         :
                            <p>
                            {pago.referencia}
                            </p>
                        }        
                        </Table.Cell>
                    
                                
                    <Table.Cell textAlign="center">
                        {pago.pagado==0?
                        <Button  color='green' onClick={(event)=>pagoSave(event ,pago.id)}>
                            <Icon name='save' /> Guardar
                        </Button>
                        :
                            ""
                        }
                    </Table.Cell>
                    </Table.Row>
                
                )}
                
                </Table.Body>
                            
            
            
            </Table>
    
        :
            
                ""
                            
            }        
    
      </Modal.Content>

  

    
    <Divider hidden/> 
                         
 
     <Modal.Actions>
        <Button  color='red' onClick={()=>closeModal(0)}>
            <Icon name='remove' /> Cerrar
        </Button>
      </Modal.Actions>
 </Segment>      
</Modal>
    
    
 
   
)

export default ModalPagos